import React, { useEffect, useState } from 'react';
import UploadCSVFilesTable from '../../components/UploadCSVFilesTable/UploadCSVFilesTable';
import { IO_UNIT_MAPPING_BULK_DOWNLOAD, IO_UNIT_MAPPING_BULK_UPLOAD } from '../../api/endpoints';
import MastersTabBar from '../../components/Common/MastersTabBar/MastersTabBar';


const IoUnitMappingUploadFiles = () => {

    const defaultData = [
        { key: '1', title: 'IO Unit Mapping', fileName: 'io_unit_mapping.csv' },
     ];

    return (
        <div className="px-6 pt-3">
            <MastersTabBar activeId="ioUnitMapping" />
            <UploadCSVFilesTable defaultData={defaultData} uploadApi = {IO_UNIT_MAPPING_BULK_UPLOAD} downloadApi ={IO_UNIT_MAPPING_BULK_DOWNLOAD}/>
        </div>
    )

};

export default IoUnitMappingUploadFiles;